const routes = [
  {
    path: 'theme',
    name: 'theme',
    component: () => import(/* webpackChunkName: "theme" */ '@/modules/theme/index.vue')
  },
];

export default routes;